import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Configuration } from './configuration';

import { CardGroupsService } from './api/cardGroups.service';
import { CardsService } from './api/cards.service';
import { DefaultService } from './api/default.service';
import { ImportService } from './api/import.service';
import { PollerRelatedOperationService } from './api/pollerRelatedOperation.service';
import { PoolsService } from './api/pools.service';
import { ProfilesService } from './api/profiles.service';
import { UsersService } from './api/users.service';

@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [],
  exports:      [],
  providers: [
    CardGroupsService,
    CardsService,
    DefaultService,
    ImportService,
    PollerRelatedOperationService,
    PoolsService,
    ProfilesService,
    UsersService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        }
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import your base AppModule only.');
        }
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/api.module.ts